<template>

  <v-dialog v-model="val" persistent width="400">
    <v-card color="info" dark>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 pa-3 sm12>
            <v-layout justify-center full-width row wrap>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap justify-center>

                  <v-flex xs12 sm12 pa-4 md12>
                       <v-layout row  justify-center>
                    <span class="title font-weight-regular ">Arkman Next</span>
                       </v-layout>
                  </v-flex>
    <v-flex xs3 sm4 pa-2 md2>
                    <v-icon large disabled  >attach_money</v-icon>

                  </v-flex>
    <v-flex xs3 sm4 pa-2 md2>
                    <v-icon large disabled   >flight_takeoff</v-icon>

                  </v-flex>
                  <v-flex xs3 pa-2 sm4 md2>
                    <v-icon large disabled  >hotel</v-icon>
                  </v-flex>


                  <v-flex xs3 sm4 pa-2 md2>
                    <v-icon large disabled   >receipt</v-icon>

                  </v-flex>
                </v-layout>
              </v-flex>

               <v-progress-linear
               color="white"
            indeterminate
            rounded
            height="5"
          ></v-progress-linear>
            </v-layout>
          </v-flex>
          <v-flex xs12 md12 pb-1 sm12>
            <v-layout justify-center full-width row wrap>
              <span class="white--text subheading">{{mesaj}}</span></v-layout>
          </v-flex>
        </v-layout>



      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value", "mesaj", "iconname"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {},
    data() {
      return {}
    },

    watch: {},
  }

  function beforeMount() {}
</script>